import {css} from '@logistics-frontend/blocks/theme/css'

export const verticalBarcode = css``

export const barcodeContainer = css`
  overflow: hidden;
`

export const barcode = css`
  inline-size: 100%;

  .${verticalBarcode} & {
    transform-origin: 0 0;
    block-size: auto;
    transform: translate(0, 0) rotate(90deg) scaleY(-30) !important; // растягивание ШК некритично - там полосы
  }
`
